module.exports = __webpack_public_path__ + "static/media/schatered.1c4945f4.svg";